import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import dealerAction from "../../redux/dealer/actions";
import manualAddFundAction from "../../redux/manualAddFund/actions";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../components/utils/Alert";
import authAction from "../../redux/auth/actions";
import Select from "react-select";
import { twoDigitDecimal } from "../../helpers/commonFunction";
import Button from "../../components/utils/Button";

function ManualAddFund() {
  const { getDealer } = dealerAction;
  const { getUserDataByToken } = authAction;
  const { manualAddFund, resetManualAddFund } = manualAddFundAction;
  const dispatch = useDispatch();
  const [addFormData, setAddFormData] = useState({
    dealerID: "",
    amount: "",
    remarks: "",
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
    setError,
  } = useForm({
    defaultValues: addFormData,
  });

  const enteredAmount = watch("amount");

  const dealerResult = useSelector((state) => state.dealer.dealerResult);
  const successMessage = useSelector(
    (state) => state.manualAddFund.manualAddFundMessage,
  );
  const errorMessage = useSelector(
    (state) => state.manualAddFund.manualAddFundError,
  );
  const updateTopUpFlag = useSelector(
    (state) => state.manualAddFund.updateManualTopUpFlag,
  );
  const { loading: buttonLoading } = useSelector(
    (state) => state.manualAddFund,
  );
  const [dealerAmountToShow, setDealerAmountToShow] = useState("0");
  const [dealerName, setDealerName] = useState("");
  const [dealerId, setDealerId] = useState("");
  const [firstChar, setFirstChar] = useState("");
  const [errorMessageForm, setErrorMessageForm] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");
  const [selectedDealer, setSelectedDealer] = useState(null);

  useEffect(() => {
    dispatch(getDealer());
  }, [successMessage]);

  useEffect(() => {
    dispatch(getUserDataByToken());
    dispatch(getDealer());
    setDealerAmountToShow("0");
    dispatch(getDealer());
  }, [updateTopUpFlag]);

  useEffect(() => {
    reset(addFormData);
  }, [addFormData]);

  useEffect(() => {
    if (errorMessage !== null && errorMessage !== undefined) {
      displayAlert(errorMessage, "alert-danger");
    }
    if (successMessage !== null && successMessage !== undefined) {
      displayAlert(successMessage, "alert-success");
      setAddFormData((prev) => ({
        ...prev,
        dealerID: "",
        amount: "",
        remarks: "",
      }));
      setDealerAmountToShow("0");
    }
  }, [errorMessage, successMessage]);

  const handleChange = (selectedOption) => {
    clearErrors(["dealerID"]);
    if (selectedOption) {
      const selectedDealer = dealerResult.find(
        (dealer) => dealer.ID === selectedOption.value,
      );
      setValue("dealerID", [selectedOption.value]);
      setSelectedDealer(selectedDealer);
      setDealerAmountToShow(selectedDealer && selectedDealer.AccountBalance);
      setDealerName(selectedDealer && selectedDealer.DealerName);
      const [firstName] =
        selectedDealer && selectedDealer.DealerName.split(" ");
      if (firstName) {
        const initials = firstName.charAt(0);
        setFirstChar(initials);
      }
      setDealerId(selectedOption.value);
    }
  };

  const handleNumber = (e) => {
    const { value } = e.target;
    if (
      !(
        e.shiftKey ||
        (e.keyCode >= 48 && e.keyCode <= 57) ||
        (e.keyCode >= 96 && e.keyCode <= 105) ||
        e.keyCode === 8 ||
        e.keyCode === 190 ||
        e.keyCode === 110
      )
    ) {
      e.preventDefault();
    }
    if ((e.keyCode === 190 || e.keyCode === 110) && value.includes(".")) {
      e.preventDefault();
    }
    if (value.includes(".")) {
      const parts = value.split(".");
      if (parts[1].length >= 2 && e.keyCode !== 8) {
        e.preventDefault();
      }
    }
  };

  const handleAmountChange = (e) => {
    setErrorMessageForm("");
    clearErrors(["amount"]);
  };

  const handleSelectFundType = (fundTypeValue) => {
    if (dealerId === "") {
      setError("dealerID", {
        type: {
          required: "Dealer required",
        },
      });
      return false;
    }

    const data = watch();
    const amount = Number(data.amount);
    if (
      (fundTypeValue === 1 || fundTypeValue === 2) &&
      !isNaN(amount) &&
      amount !== 0 &&
       Math.abs(amount) <= 99999 &&
      data.remarks !== ""
    ) {
      const submitDealerFund = {
        dealerId: dealerId,
        amount: amount,
        fundType: fundTypeValue,
        remarks: data.remarks,
      };
      dispatch(manualAddFund(submitDealerFund));
    } else {
      // setErrorMessageForm("Invalid amount.");
    }
  };

  const displayAlert = (text, type) => {
    reset({
      dealerID: "",
    });
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
    dispatch(resetManualAddFund());
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
    dispatch(resetManualAddFund());
  };

  const options = dealerResult
    .filter((dealer) => dealer.ParentID !== 0)
    .map((dealer) => ({
      label: dealer.DealerName,
      value: dealer.ID,
    }));

  const dealerSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "46px",
      borderRadius: "9px",
      backgroundColor: "rgba(255,255,255,0.96)",
      borderColor: state.isFocused ? "#C9A227" : "rgba(255,255,255,0.15)",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(201,162,39,0.22)" : "none",
      "&:hover": { borderColor: "#C9A227" },
    }),
    placeholder: (base) => ({ ...base, color: "#8A8676", fontSize: "14px" }),
    singleValue: (base) => ({ ...base, fontSize: "14px", color: "#14264C" }),
    option: (base, state) => ({
      ...base,
      fontSize: "14px",
      backgroundColor: state.isSelected
        ? "#14264C"
        : state.isFocused
          ? "#F1EFE7"
          : "#fff",
      color: state.isSelected ? "#F4F1E8" : "#14264C",
    }),
  };

  return (
    <div id="content-page" className="content-page ">
      <div className="maf-shell">
        <div className="maf-eyebrow">Dealer Accounts</div>
        <h1 className="maf-title">Manual Fund Adjustment</h1>
        <p className="maf-subtitle">
          Top up or deduct funds directly from a dealer&apos;s account balance.
        </p>

        {showAlert && (
          <div className="maf-alert-wrap">
            <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
          </div>
        )}

        <form onSubmit={handleSubmit(handleSelectFundType)}>
          <div className="maf-panel">
            {/* Left: dealer + balance stub */}
            <div className="maf-stub">
              <div className="maf-chip" />
              <div className="maf-stub-label">Dealer</div>
              <div className="maf-select-wrap">
                <Controller
                  control={control}
                  defaultValue={options.map((c) => c.value)}
                  name="dealerID"
                  rules={{ required: true }}
                  render={({ field: { onChange, value, ref } }) => (
                    <Select
                      className="basic-single"
                      placeholder={"Select dealer.."}
                      value={options.filter((c) => value.includes(c.value))}
                      onChange={handleChange}
                      options={options}
                      isSearchable={true}
                      styles={dealerSelectStyles}
                    />
                  )}
                />
                {errors.dealerID && (
                  <div className="maf-error">Please select a dealer!</div>
                )}
              </div>

              <div className="maf-divider-notch" />

              <div className="maf-balance-label">Current Balance</div>
              <div className="maf-balance-value">
                <span className="maf-balance-currency">$</span>
                {twoDigitDecimal(dealerAmountToShow)}
              </div>

              <div className="maf-dealer-id-row">
                <div className="maf-avatar">{firstChar}</div>
                <div>
                  <div className="maf-dealer-name">{dealerName || "—"}</div>
                  <div className="maf-dealer-tag">Account holder</div>
                </div>
              </div>
            </div>

            {/* Right: transaction fields */}
            <div className="maf-form-side">
              <div className="maf-field-block">
                <label className="maf-field-label">Amount</label>
                <div className="maf-amount-row">
                  <span className="maf-amount-currency">$</span>
                  <input
                    className="maf-amount-input"
                    type="number"
                    name="amount"
                    placeholder="0.00"
                    {...register("amount", {
                      required: true,
                      min: 0.01,
                      max: 99999,
                    })}
                    onChange={handleAmountChange}
                    onKeyDown={handleNumber}
                  />
                </div>
                {errorMessageForm && (
                  <div className="maf-error">{errorMessageForm}</div>
                )}
                {errors.amount?.type === "required" && (
                  <div className="maf-error">Amount is required!</div>
                )}
                {errors.amount?.type === "min" && (
                  <div className="maf-error">
                    Amount must be greater than zero!
                  </div>
                )}
                {errors.amount?.type === "max" && (
                  <div className="maf-error">
                    Amount must be less than 99999!
                  </div>
                )}
              </div>

              <div className="maf-field-block">
                <label className="maf-field-label">Remark</label>
                <input
                  type="text"
                  className="maf-remarks-input"
                  placeholder="Reason for this adjustment"
                  name="remarks"
                  {...register("remarks", {
                    required: true,
                  })}
                />
                {errors.remarks?.type === "required" && (
                  <div className="maf-error">Remark is required!</div>
                )}
              </div>

              <div className="maf-actions">
                <Button
                  title={"Deduct"}
                  onClick={() => handleSelectFundType(2)}
                  buttonClass="maf-btn maf-btn-deduct"
                  loading={buttonLoading}
                  buttonType="submit"
                />
                <Button
                  title={"Add Top Up"}
                  onClick={() => handleSelectFundType(1)}
                  buttonClass="maf-btn maf-btn-add"
                  loading={buttonLoading}
                  buttonType="submit"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ManualAddFund;
